import SSTORAGE from './storage/session';

import GNav from './header/gnav';
import HeaderLang from './header/lang';
import ScrollAnime from './anime/scroll';
import Character from './character/main';
import Modal from './modal/main';
import Movie from "./modal/movie";
import Anchor from './utils/anchor';
import PrivacyPolicy from './privacy/main';
import Footer from './footer/main';


export default class Main{
    
    constructor(){
        this._init();
    }
    
    _init(){
        window.VILE = {};

        const gnav = new GNav();
        const lang = new HeaderLang();
        const scroll = new ScrollAnime();

        const modal = new Modal();
        const movie = new Movie();
        const policy = new PrivacyPolicy();
        //const footer = new Footer();

        window.VILE.anchor = new Anchor();
        window.VILE.session = new SSTORAGE();

        if(document.querySelector('.c-chara')){
            const chara = new Character();
        }

        setTimeout(()=>{
            document.body.classList.add('-ready');
        }, 500);
    }
}